module.exports = __webpack_public_path__ + "img/repuagency-logo-dark.png";